/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester ce n'est pas un composant react*/

const isEcoWebInlineImage = (domNode) => {
  return domNode.attribs && domNode.attribs['data-gatsby-image-wrapper'] !== undefined;
};

const isAccordeonDomNode = (domNode) => {
  return domNode.attribs && domNode.attribs.class === 'accordeon';
};

const isScript = (domNode) => {
  return domNode.name === 'script';
};

// Scripts tiers de confiance : execution directe dans le document reel (pas d'iframe sandbox)
// car ils doivent pouvoir cibler un element du vrai DOM (ex: bandeau cookies Cookiebot).
const TRUSTED_SCRIPT_HOSTS = ['consent.cookiebot.com'];

const isTrustedScriptSrc = (src) => {
  if (!src) return false;
  try {
    const { hostname } = new URL(src, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return TRUSTED_SCRIPT_HOSTS.includes(hostname);
  } catch {
    return false;
  }
};

const isShowMoreDomNode = (domNode) => {
  return domNode.name === 'more';
};

const isLinkBoxSticky = (domNode) => {
  return domNode.attribs && domNode.attribs.class === 'linkBoxSticky';
};

const isAuthorQuote = (domNode) => {
  return domNode.attribs && domNode.attribs.class === 'author-quote';
};

const nodeToEcoWebInlineImage = (domNode) => {
  if (domNode.children) {
    domNode.children.forEach((n, idx) => {
      if (idx === 1) {
        n.attribs.style = 'height: 100%; left: 0px; position: absolute; top: 0px; width: 100%; opacity: 0;';
      } else if (idx === 2) {
        n.attribs.style =
          'height: 100%;\
          left: 0px;\
          position: absolute;\
          top: 0px;\
          transform: translateZ(0px);\
          transition: opacity 250ms linear 0s;\
          width: 100%;\
          will-change: opacity;\
          opacity: 1;\
          ';
      }
    });
  }

  return domNode;
};

module.exports = {
  isAuthorQuote,
  isAccordeonDomNode,
  isLinkBoxSticky,
  isScript,
  isTrustedScriptSrc,
  isEcoWebInlineImage,
  nodeToEcoWebInlineImage,
  isShowMoreDomNode,
};
